export default __webpack_public_path__ + "static/media/paralax3.8f97c2c1.jpg";